import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import {
  DeleteWorkstep,
  DeleteWorkstepComponent,
  EditWorkStep,
  EditWorkstepComponent,
} from "../../../actions/teacherMutations";
import { formatServiceError } from "../../../Utilities/serviceErrorHelper";

export default function useAPLWorkStepMutations(intl, level, activePeriodId, objId) {
  const [promtWorkComponentForDelete, setPromptComponentForDelete] =
    useState(null);
  const [workcardItemForEditName, setWorkcardItemForEditName] = useState(null);

  const queryClient = useQueryClient();

  const deleteWorkstep = useMutation({ mutationFn: DeleteWorkstep });
  const deleteWorkstepComponent = useMutation({ mutationFn: DeleteWorkstepComponent });
  const editWorkStep = useMutation({ mutationFn: EditWorkStep });
  const editWorkStepComponent = useMutation({ mutationFn: EditWorkstepComponent });

  const handleDeleteItem = () => {
    if (promtWorkComponentForDelete.isWorkstep) {
      deleteWorkstep.mutate(promtWorkComponentForDelete.id, {
        onError: (err) => {
          toast.warn(formatServiceError(intl, err?.response?.data));
        },
        onSuccess: () => {
          toast.success(
            intl.formatMessage(
              { id: "WorkstepNameDeleted" },
              {
                name: promtWorkComponentForDelete.name,
              }
            )
          );
          queryClient.invalidateQueries({ queryKey: [
            "FetchWorkCardHours",
            [level, activePeriodId, objId],
          ] });
        },
      });
    } else if (!promtWorkComponentForDelete.isWorkstep) {
      deleteWorkstepComponent.mutate(promtWorkComponentForDelete.id, {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: [
            "FetchWorkCardHours",
            [level, activePeriodId, objId],
          ] });
          toast.success(
            intl.formatMessage(
              { id: "WorkstepComponentNameDeleted" },
              {
                name: promtWorkComponentForDelete.name,
              }
            )
          );
          setWorkcardItemForEditName(null);
        },
        onError: (err) => {
          toast.warn(formatServiceError(intl, err?.response?.data));
        },
      });
    }
    setPromptComponentForDelete(null);
  };

  const handleChangeNameOnWorkcardItem = () => {
    if (workcardItemForEditName.isWorkstep) {
      editWorkStep.mutate(workcardItemForEditName, {
        onError: (err) => {
          toast.warn(formatServiceError(intl, err?.response?.data));
          setWorkcardItemForEditName(null);
        },
        onSuccess: () => {
          toast.success(
            intl.formatMessage(
              { id: "WorkstepNameChangedTo" },
              {
                name: workcardItemForEditName.name,
              }
            )
          );
          queryClient.invalidateQueries({ queryKey: [
            "FetchWorkCardHours",
            [level, activePeriodId, objId],
          ] });
          setWorkcardItemForEditName(null);
        },
      });
    } else if (!workcardItemForEditName.isWorkstep) {
      editWorkStepComponent.mutate(workcardItemForEditName, {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: [
            "FetchWorkCardHours",
            [level, activePeriodId, objId],
          ] });
          toast.success(
            intl.formatMessage(
              { id: "WorkstepComponentNameChangedTo" },
              {
                name: workcardItemForEditName.name,
              }
            )
          );
          setWorkcardItemForEditName(null);
        },
        onError: (err) => {
          toast.warn(formatServiceError(intl, err?.response?.data));
          setWorkcardItemForEditName(null);
        },
      });
    }
    setPromptComponentForDelete(null);
  };

  const handleSetWorkcardItemForEditName = (val) => {
    setWorkcardItemForEditName({ ...workcardItemForEditName, name: val });
  };

  return {
    promtWorkComponentForDelete,
    setPromptComponentForDelete,
    workcardItemForEditName,
    setWorkcardItemForEditName,
    handleDeleteItem,
    handleChangeNameOnWorkcardItem,
    handleSetWorkcardItemForEditName,
  };
}
